var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map_holder"},[(_vm.showBaseLayerControl)?_c('BaseLayer',{attrs:{"map-id":_vm.id,"options":_vm.baseLayerControlOptions}}):_vm._e(),_c('div',{staticClass:"map",style:(_vm.style),attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }